import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseControl, Dropdown, Option } from '@app/shared';


@Injectable()
export class ProcedureStatusFormService {
  constructor() { }

  /**
   * Retorna el formulario de cambio de estado de expedientes
   *
   * @param {MotivoStatusChange} [observation]
   * @returns {BaseControl<any>[]}
   * @memberof ProcedureStatusFormService
   */
  getFields(status: Option[], procedure_status?: string): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
       new Dropdown({
            key: 'cboEstado',
            label: 'Estado:',
            value: procedure_status ? status ? status.find((s: Option) => s.value === procedure_status)? status.find((s: Option) => s.value === procedure_status).key : null: null
                  : null,
            options: status,
            order: 1,
            validations: {
              validators: [Validators.required]
            }
          }),
      
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/procedure-status-utility/shared/procedure-status-utility.form.service.ts